import React, { useState, useRef } from 'react';
import './home_page.css';
import { socialLinks } from '../footer/socialLinks';

// SVG Icon Components
const GitHubIcon = () => (
    <svg className="box-icon-svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    </svg>
);

const LinkedInIcon = () => (
    <svg className="box-icon-svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
);

const InstagramIcon = () => (
    <svg className="box-icon-svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.017 0C8.396 0 7.609.034 6.298.154 4.987.275 4.014.59 3.252.968c-.806.39-1.49.984-2.085 1.728C.39 3.44.086 4.413.034 5.724-.034 7.035 0 7.822 0 11.443s.034 4.408.154 5.719c.121 1.311.436 2.284.814 3.046.39.806.984 1.49 1.728 2.085.744.595 1.717.91 3.028.91 1.311 0 2.098.034 3.409.154 1.311.121 2.284.436 3.046.814.806.39 1.49.984 2.085 1.728.595.744.91 1.717.91 3.028 0 1.311.034 2.098.154 3.409.121 1.311.436 2.284.814 3.046.39.806.984 1.49 1.728 2.085C20.56 23.61 21.533 23.914 22.844 23.966c1.311.052 2.098 0 3.409 0s2.098-.034 3.409-.154c1.311-.121 2.284-.436 3.046-.814.806-.39 1.49-.984 2.085-1.728C23.61 20.56 23.914 21.533 23.966 22.844c.052 1.311 0 2.098 0 3.409s-.034 2.098-.154 3.409c-.121 1.311-.436 2.284-.814 3.046-.39.806-.984 1.49-1.728 2.085-.744.595-1.717.91-3.028.91-1.311 0-2.098.034-3.409.154-1.311.121-2.284.436-3.046.814-.806.39-1.49.984-2.085 1.728-.595.744-.91 1.717-.91 3.028 0 1.311-.034 2.098-.154 3.409-.121 1.311-.436 2.284-.814 3.046-.39.806-.984 1.49-1.728 2.085C3.44.39 4.413.086 5.724.034 7.035-.034 7.822 0 11.443 0s4.408-.034 5.719-.154c1.311-.121 2.284-.436 3.046-.814.806.39 1.49.984 2.085 1.728C20.56.39 21.533.086 22.844.034 24.155-.034 24.942 0 28.563 0s4.408.034 5.719.154c1.311.121 2.284.436 3.046.814.806.39 1.49.984 2.085 1.728.595.744.91 1.717.91 3.028 0 1.311.034 2.098.154 3.409.121 1.311.436 2.284.814 3.046.39.806.984 1.49 1.728 2.085.744.595 1.717.91 3.028.91 1.311 0 2.098.034 3.409.154 1.311.121 2.284.436 3.046.814.806.39 1.49.984 2.085 1.728C.39 3.44.086 4.413.034 5.724-.034 7.035 0 7.822 0 11.443" />
        <path d="M12.017 5.839A6.163 6.163 0 0 0 5.854 12c0 3.403 2.751 6.164 6.163 6.164s6.164-2.761 6.164-6.164c0-3.403-2.751-6.164-6.164-6.164zm0 10.073A3.909 3.909 0 0 1 8.108 12c0-2.157 1.751-3.909 3.909-3.909s3.909 1.752 3.909 3.909-1.751 3.909-3.909 3.909z" />
        <circle cx="18.406" cy="5.594" r="1.44" />
    </svg>
);

const HomePage = () => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const longPressTimer = useRef(null);

    // Three different arrangements for the boxes
    const arrangements = [
        [
            { id: 'github', icon: <GitHubIcon />, title: 'GitHub', description: 'Check out my code repositories', link: socialLinks.github },
            { id: 'linkedin', icon: <LinkedInIcon />, title: 'LinkedIn', description: 'Connect with me professionally', link: socialLinks.linkedin },
            { id: 'instagram', icon: <InstagramIcon />, title: 'Instagram', description: 'Follow my creative journey', link: socialLinks.instagram }
        ],
        [
            { id: 'linkedin', icon: <LinkedInIcon />, title: 'LinkedIn', description: 'Connect with me professionally', link: socialLinks.linkedin },
            { id: 'instagram', icon: <InstagramIcon />, title: 'Instagram', description: 'Follow my creative journey', link: socialLinks.instagram },
            { id: 'github', icon: <GitHubIcon />, title: 'GitHub', description: 'Check out my code repositories', link: socialLinks.github }
        ],
        [
            { id: 'instagram', icon: <InstagramIcon />, title: 'Instagram', description: 'Follow my creative journey', link: socialLinks.instagram },
            { id: 'github', icon: <GitHubIcon />, title: 'GitHub', description: 'Check out my code repositories', link: socialLinks.github },
            { id: 'linkedin', icon: <LinkedInIcon />, title: 'LinkedIn', description: 'Connect with me professionally', link: socialLinks.linkedin }
        ]
    ];

    const [currentArrangement, setCurrentArrangement] = useState(0);
    const currentBoxes = arrangements[currentArrangement];

    const handleLongPressStart = () => {
        longPressTimer.current = setTimeout(() => {
            setIsEditMode(true);
        }, 500); // 500ms for long press
    };

    const handleLongPressEnd = () => {
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
        }
    };

    const handleBoxClick = (index) => {
        if (isEditMode) {
            // Cycle through arrangements
            setCurrentArrangement((prev) => (prev + 1) % arrangements.length);
        }
    };

    const handleDragStart = (e, index) => {
        if (!isEditMode) return;
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e) => {
        if (!isEditMode) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleDrop = (e, dropIndex) => {
        if (!isEditMode || draggedIndex === null) return;
        e.preventDefault();

        const newArrangement = [...currentBoxes];
        const draggedItem = newArrangement[draggedIndex];
        newArrangement.splice(draggedIndex, 1);
        newArrangement.splice(dropIndex, 0, draggedItem);

        // Update the current arrangement with the new order
        const updatedArrangements = [...arrangements];
        updatedArrangements[currentArrangement] = newArrangement;
        // Note: In a real app, you'd want to persist this state

        setDraggedIndex(null);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };

    const exitEditMode = () => {
        setIsEditMode(false);
    };

    return (
        <div className="home-container" onClick={isEditMode ? exitEditMode : undefined}>
            {/* Decision Tree Structure */}
            <div className="decision-tree">
                {/* Large Intro Box */}
                <div className="intro-box">
                    <div className="intro-content">
                        <h1 className="intro-title">Welcome</h1>
                        <p className="intro-subtitle">Flutter Developer | Node.js | ML Enthusiast</p>
                        <p className="intro-description">
                            I build beautiful cross-platform mobile applications with Flutter and exploring
                            the world of Machine Learning. Passionate about creating seamless user experiences
                            across iOS, Android, and Web.
                        </p>
                    </div>
                </div>

                {/* Connecting Lines */}
                <div className="connecting-lines">
                    <div className="line line-1"></div>
                    <div className="line line-2"></div>
                    <div className="line line-3"></div>
                </div>

                {/* Three Derived Boxes */}
                <div className="derived-boxes">
                    {currentBoxes.map((box, index) => (
                        <div
                            key={box.id}
                            className={`derived-box ${box.id}-box ${isEditMode ? 'edit-mode' : ''} ${draggedIndex === index ? 'dragging' : ''}`}
                            onMouseDown={handleLongPressStart}
                            onMouseUp={handleLongPressEnd}
                            onMouseLeave={handleLongPressEnd}
                            onTouchStart={handleLongPressStart}
                            onTouchEnd={handleLongPressEnd}
                            onClick={() => handleBoxClick(index)}
                            draggable={isEditMode}
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, index)}
                            onDragEnd={handleDragEnd}
                        >
                            <a href={box.link} target="_blank" rel="noopener noreferrer" className="box-link">
                                <div className="box-content">
                                    <div className="box-icon">{box.icon}</div>
                                    <h3>{box.title}</h3>
                                    <p>{box.description}</p>
                                </div>
                            </a>
                            {isEditMode && (
                                <div className="edit-indicator">
                                    <span className="edit-icon">✏️</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {isEditMode && (
                <div className="edit-mode-overlay">
                    <p>Tap outside or click to exit edit mode</p>
                </div>
            )}
        </div>
    );
};

export default HomePage;
